// import getTurnAroundTime from "@custom/rtk-apis/analytics/getTurnAroundTime";
import getPeerReview from "@custom/rtk-apis/analytics/getPeerReview";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getPeerReviewSlice = createSlice({
  name: "getPeerReviewSlice",
  initialState,
  reducers: {
    clearPeerReview: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPeerReview.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getPeerReview.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload.data;
        state.msg = payload.msg;
      })
      .addCase(getPeerReview.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getPeerReviewSlice.reducer;
export const { clearPeerReview } = getPeerReviewSlice.actions;
